module.exports = __webpack_public_path__ + "img/frame.4a93c68e.png";